import { useContext } from 'react'
import { IPortalContext, PortalContext } from '../providers/PortalProvider'

export default function usePortalTarget(): IPortalContext {
  return useContext<IPortalContext>(PortalContext)
}
